document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("main table.table")) {
        import(/* webpackChunkName: "table-horizontal-scroller" */ "/Assets/libs/table-horizontal-scroller/table-horizontal-scroller.js").then(async (module) => {
            const tableHorizontalScroller = new module.default();
            await tableHorizontalScroller.init();
        });
    }
});
